import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Context from "../../Context/ApplicationContext";

const PrivateRoute = ({ children }) => {
  const { isLogged } = useContext(Context);

  if (!isLogged) {
    return <Navigate to="/login" replace />;
  }

  return children ? children : <Outlet />;
};



export default PrivateRoute;
